"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Providers = exports.SwitchVip = exports.ProvidersSelectLight = exports.ProvidersBlockWithGameAlternative = exports.PolicyWithNavigate = exports.PolicyAlternative = exports.LoyaltyCardAlternative = exports.LimitedOfferWithBackground = exports.HeaderWithCashback = exports.FooterFlat = exports.DynamicH1 = void 0;
var DynamicH1_1 = require("./DynamicH1");
Object.defineProperty(exports, "DynamicH1", { enumerable: true, get: function () { return DynamicH1_1.DynamicH1; } });
var FooterFlat_1 = require("./FooterFlat");
Object.defineProperty(exports, "FooterFlat", { enumerable: true, get: function () { return __importDefault(FooterFlat_1).default; } });
var HeaderWithCashback_1 = require("./HeaderWithCashback");
Object.defineProperty(exports, "HeaderWithCashback", { enumerable: true, get: function () { return HeaderWithCashback_1.HeaderWithCashback; } });
var LimitedOfferWithBackground_1 = require("./LimitedOfferWithBackground");
Object.defineProperty(exports, "LimitedOfferWithBackground", { enumerable: true, get: function () { return __importDefault(LimitedOfferWithBackground_1).default; } });
var LoyaltyCard_1 = require("./LoyaltyCard");
Object.defineProperty(exports, "LoyaltyCardAlternative", { enumerable: true, get: function () { return __importDefault(LoyaltyCard_1).default; } });
__exportStar(require("./Payments"), exports);
var Policy_1 = require("./Policy");
Object.defineProperty(exports, "PolicyAlternative", { enumerable: true, get: function () { return __importDefault(Policy_1).default; } });
var PolicyWithNavigate_1 = require("./PolicyWithNavigate");
Object.defineProperty(exports, "PolicyWithNavigate", { enumerable: true, get: function () { return __importDefault(PolicyWithNavigate_1).default; } });
var ProvidersBlockWithGame_1 = require("./ProvidersBlockWithGame");
Object.defineProperty(exports, "ProvidersBlockWithGameAlternative", { enumerable: true, get: function () { return __importDefault(ProvidersBlockWithGame_1).default; } });
var ProvidersSelectLight_1 = require("./ProvidersSelectLight");
Object.defineProperty(exports, "ProvidersSelectLight", { enumerable: true, get: function () { return __importDefault(ProvidersSelectLight_1).default; } });
var SwitchVip_1 = require("./SwitchVip");
Object.defineProperty(exports, "SwitchVip", { enumerable: true, get: function () { return __importDefault(SwitchVip_1).default; } });
__exportStar(require("./WheelOfFortune"), exports);
var Providers_1 = require("./Providers");
Object.defineProperty(exports, "Providers", { enumerable: true, get: function () { return __importDefault(Providers_1).default; } });
